import styled from 'styled-components';
import tw from 'twin.macro';

export const Container = styled.div.attrs({
  className: 'hidden sm:block',
})`
  width: 303px;
  border-radius: 20px;
  background: white;
  position: fixed;
  top: 100px;
  right: 20px;
  box-shadow: 0px 2px 7px 1px rgba(0, 0, 0, 0.5);
  z-index: 10;
  padding: 30px;

  .header {
    svg {
      width: 35px;
      height: 35px;
    }
  }
`;

export const MenuContainer = styled.div.attrs({})`
  .menu-item-wrapper {
    width: 100%;
    padding: 5px 0px;
    cursor: pointer;

    &:hover {
      a.menu-item,
      .account-item {
        color: white;
      }
    }

    a.menu-item,
    .account-item {
      ${tw`text-gray-200`}
      font-weight: normal;
      width: 100%;
      height: 100%;
    }

    &:hover {
      background: #0f0c35;
    }
  }

  .divider {
    height: 1px;
    background: #3f3f3f;
    margin: 10px 5px;
  }
`;
